import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Component({
    selector: 'happy-list',
    templateUrl: './happy-list.component.html',
    styleUrls: ['./happy-list.component.css']
})
export class HappyListComponent implements OnInit {

    @Input() items$: Observable<any>;
    @Input() config: ListConfig;
    @Input() templateRef: ElementRef;
    @Input() groupTemplateRef: ElementRef;

    searchChanged$ = new Subject<string>();
    processedItems$: Observable<Array<{ matches: boolean }>>;
    groupedItems$: Observable<Array<{ group, items: Array<{ matches: boolean }> }>>;
    @Output() onItemClick = new EventEmitter();

    constructor() {
    }

    ngOnInit() {

        if (!(this.config && this.config instanceof ListConfig)) {
            throw Error('Missing input property ListConfig');
        }

        const { nestedConfig } = this.config;
        if (nestedConfig) {
            const { flatten } = nestedConfig;
            this.groupedItems$ = Observable.combineLatest(
                this.items$.map(groups => groups.map(group => ({ group, items: flatten(group) }))),
                this.searchChanged$.startWith('')
            )
                .map(([placeholders, search]) => this.sortGroups(placeholders, search))
                .shareReplay();
        } else {
            this.processedItems$ = Observable.combineLatest(
                this.items$,
                this.searchChanged$.startWith('')
            )
                .map(([placeholders, search]) => this.sortPlaceholders(placeholders, search))
                .shareReplay();
        }
    }

    private sortGroups(groups: Array<{ group, items: Array<any> }>, search: string): Array<{ group, items: Array<{ matches: boolean }> }> {
        return groups
            .map(({group, items}) => ({
                group,
                items: items
                    .map(i => ({ ...i, matches: this.config.matcher(i, search) }))
                    .filter(i => i.matches)
                    .sort((a, b) => {
                        if (a.matches !== b.matches) {
                            return a.matches ? -1 : 1;
                        }

                        return this.config.comparator(a, b);
                    })
            }))
            .filter(g => g.items.length > 0);
    }

    private sortPlaceholders(items: Array<any>, search: string): Array<{ matches: boolean }> {
        if(items)
        return items
            .map(placeholder => ({ ...placeholder, matches: this.config.matcher(placeholder, search) }))
            .sort((a, b) => {
                if (a.matches !== b.matches) {
                    return a.matches ? -1 : 1;
                }

                return this.config.comparator(a, b);
            });
    }

    onSearchChange(search: string) {
        this.searchChanged$.next(search);
    }

    onItemClicked(event: MouseEvent, item) {
        this.onItemClick.emit({ event, item });
    }
}

export class ListConfig {

    constructor(public readonly matcher: (item, search) => boolean,
                public readonly comparator: (a, b) => number,
                public readonly nestedConfig?: INestedConfig) {
    }
}

export interface INestedConfig {
    flatten: (group) => Array<any>;
}




// WEBPACK FOOTER //
// ./src/app/shared/components/happy/happy-list/happy-list.component.ts